const StudyPackCard = ({ document }) => {
  const title = document?.Title ?? document?.title ?? "";
  const description = document?.Description ?? document?.description ?? "";
  const path = document?.Path ?? document?.path ?? document.URL ?? "";

  return (
    <div className="group w-72 rounded-lg border border-gray-200 bg-gray-100 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md">
      {/* Image only (no title/description overlay) */}
      <div className="flex justify-center items-center bg-gray">
        <svg
          width="128"
          height="128"
          viewBox="0 0 64 64"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="12"
            y="8"
            width="40"
            height="48"
            rx="4"
            ry="4"
            fill="#ffffff"
            stroke="#d1d5db"
          />

          <polygon points="40,8 52,20 40,20" fill="#e5e7eb" />

          <rect x="18" y="26" width="28" height="2.5" fill="#60a5fa" />
          <rect x="18" y="32" width="24" height="2.5" fill="#93c5fd" />
          <rect x="18" y="38" width="20" height="2.5" fill="#bfdbfe" />
        </svg>
      </div>

      {/* Bottom content section */}
      <div className="flex bg-white flex-col gap-2 p-4">
        <h3 className="text-sm font-bold text-gray-900 line-clamp-1">
          {title}
        </h3>

        {description && (
          <p className="text-xs text-gray-600 line-clamp-2">{description}</p>
        )}

        <div className="pt-1">
          {path ? (
            <a
              href={path}
              target="_blank"
              download
              className="inline-flex items-center rounded bg-primary-600 px-3 py-1.5 text-xs font-medium text-white hover:bg-primary-700"
            >
              Download PDF
            </a>
          ) : (
            <span className="inline-flex items-center rounded bg-gray-200 px-3 py-1.5 text-xs font-medium text-gray-500">
              Unavailable
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default StudyPackCard;
